import React from "react";
import { Button, Flex, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { Text } = Typography;

export interface ConfigPanelShellProps {
    title: string;
    onClose: () => void;
    showHelp?: boolean;
    helpContent?: { title?: string; body: string };
    onHelpToggle?: () => void;
    children: React.ReactNode;
    footer?: React.ReactNode;
}

/**
 * Shared layout for step config panels: header (title, close, optional help),
 * body slot, and optional footer slot.
 */
export const ConfigPanelShell: React.FC<ConfigPanelShellProps> = ({
    title,
    onClose,
    showHelp = false,
    helpContent,
    onHelpToggle,
    children,
    footer,
}) => {
    return (
        <div className="trigger-rule-config-panel d-flex flex-column h-100">
            <div className="trigger-rule-config-panel-header d-flex align-items-center justify-content-between">
                <Flex align="center" gap={8}>
                    <Text className="trigger-rule-config-panel-title hs-fw-600 hs-fs-16 hs-color-BlackRussian">
                        {title}
                    </Text>
                    {onHelpToggle && (
                        <div
                            className="automationIconsSprite help-icon cursor-pointer"
                            onClick={onHelpToggle}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    onHelpToggle();
                                }
                            }}
                            aria-label={showHelp ? "Hide help" : "Show help"}
                        />
                    )}
                </Flex>
                <Button
                    type="text"
                    className="trigger-rule-config-panel-close"
                    onClick={onClose}
                    aria-label="Close"
                    icon={<CloseOutlined />}
                />
            </div>
            <div className="trigger-rule-config-panel-body py-3 px-3">
                {showHelp && helpContent && (
                    <div className="trigger-rule-config-panel-help-content mb-3">
                        <Text className="hs-fs-14 hs-color-mediumDark">How it works</Text>
                        <Text className="hs-fs-12 hs-color-mediumDark d-block mt-1">
                            {helpContent.body}
                        </Text>
                    </div>
                )}
                {children}
            </div>
            {footer}
        </div>
    );
};
